import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const RegimeSocial = [
  'MSA',
  'URSSAF',
] as const

export type RegimeSocial = typeof RegimeSocial[number]

export const RegimeSocialLibelle: UnionTypeLibelle<RegimeSocial> = {
  MSA: '1 - MSA',
  URSSAF: '2 - URSSAF',
} as const
